import { Loader } from '@mantine/core';

type props = {
  color?: string;
};

const ActiveStatusSpinner = ({ color }: props) => {
  return (
    <Loader
      style={{
        '--loader-size': '15px',
        animationDuration: '1.0s',
        marginLeft: '1px',
        marginRight: '1px',
      }}
      color={color || '#51ADFF'}
    />
  );
};

export default ActiveStatusSpinner;
